import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import EmailService from '../../services/EmailService';

const EmailEdit = () => {
  const [recipient_name, setRecipientName] = useState('');
  const [recipient_email, setRecipientEmail] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    fetchEmail();
  }, []);

  const fetchEmail = async () => {
    try {
      const data = await EmailService.get(id);
      setRecipientName(data.recipient_name);
      setRecipientEmail(data.recipient_email);
    } catch (error) {
      console.error('Error fetching email:', error);
      Swal.fire('Error!', 'Failed to fetch email details.', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await EmailService.update(id, { recipient_name, recipient_email });
      Swal.fire('Updated!', 'Email updated successfully.', 'success');
      navigate('/emails');
    } catch (error) {
      console.error('Error updating email:', error);
      Swal.fire('Error!', 'Failed to update email. Please try again.', 'error');
    }
  };

  const handleCancel = () => {
    navigate('/emails');
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Edit Email</h4>
              <p className="card-description">Update recipient details</p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Recipient Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={recipient_name}
                    onChange={(e) => setRecipientName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Recipient Email</label>
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    value={recipient_email}
                    onChange={(e) => setRecipientEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-sm">Update</button>
                <button
                  type="button"
                  className="btn btn-light btn-sm"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailEdit;
